/**
 * Card primitive — restyled for the Abyss visual identity (Phase 2).
 *
 * Frosted-glass surface: backdrop-blur-lg, surface-glass fill,
 * surface-stroke ring, glass shadow. No API change — all existing
 * CardHeader / CardTitle / CardBody / CardFooter callers keep compiling.
 */
import { type HTMLAttributes } from 'react';
import clsx from 'clsx';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        'rounded-2xl',
        'backdrop-blur-lg',
        'bg-surface-glass',
        'ring-1 ring-surface-stroke',
        'shadow-glass',
        className,
      )}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('px-4 pt-4 pb-2', className)} {...props} />;
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      className={clsx('text-sm font-semibold tracking-wide text-text-1', className)}
      {...props}
    />
  );
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('px-4 pb-4', className)} {...props} />;
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={clsx('px-4 pb-4 pt-2 text-xs text-text-3', className)} {...props} />;
}
